import Vue from "vue";
import axios from "axios";
import TcVod from "vod-js-sdk-v6";
// import BaseConfig from "../../configRrj/BaseConfig";
// import * as types from "../mutation-types";
import request from "@/utils/request";

const CREATE_UPLOAD = "CREATE_UPLOAD";
const UPDATE_UPLOAD = "UPDATE_UPLOAD";
const DELETE_UPLOAD = "DELETE_UPLOAD";

// /* eslint-disable */
const state = [];
const checkpoint = {};
const globalArr = []; // 待上传数组
// 待上传数组应该放到本地存储或者vuex的另一个store里面，否则切换页面会销毁
// 取消操作，如果没有在上传的话会取消不了

const mutations = {
  [CREATE_UPLOAD](st, upload) {
    for (let i = 0; i < st.state.length; i++) {
      if (st.state[i].activity.id === upload.activity.id) {
        st.state.splice(i, 1);
      }
    }
    state.unshift(upload);
  },
  [UPDATE_UPLOAD](st, upload) {
    console.log("state", state);
    for (let i = 0; i < st.state.length; i++) {
      if (st.state[i].activity.id === upload.activity.id) {
        /* eslint-disable */
        for (const key in upload) {
          st.state[i][key] = upload[key];
        }

        /* eslint-enable */
      }
    }

    if (upload.status === 3) {
      // setTimeout(() => {
      const index = st.state.findIndex(
        (val) => val.activity.id === upload.activity.id
      );
      st.state.splice(index, 1);
      // }, 2000);
    }
  },
  [DELETE_UPLOAD](st, activityId) {
    checkpoint[`act_${activityId}`] = null;
    for (let i = 0; i < st.state.length; i++) {
      if (st.state[i].activity.id === activityId) {
        st.state.splice(i, 1);
      }
    }
  },
};

const actions = {
  createUpload(
    { commit, dispatch },
    { file, activity, isHighVod, horizontal }
  ) {
    // 音频文件列表
    const audioFileFixs = ["mp3", "m4a", "wav", "aac"];
    let upload = {};

    for (let i = 0; i < state.length; i++) {
      if (state[i].activity.id === activity.id) {
        upload = state[i];
      }
    }
    console.log("uploadFormCommitBtnCliced111", activity);

    // 兼容重试调用
    if (!upload.storeAs || upload.activity.restart === true) {
      const fileFix = file.name.replace(/.+\./, "").toLowerCase(); // 文件后缀
      const isAudio = audioFileFixs.indexOf(fileFix) > -1;
      const stroeName = `${activity.id}_${new Date().getTime()}`; // 文件存储名称
      const txStoreName = `tx_activity_${activity.id}_${new Date().getTime()}`; // 文件存储名称
      let storeAs = "";
      debugger;
      if (isAudio) {
        storeAs = `/upload_audio/${stroeName}.${fileFix}`;
      } else {
        if (isHighVod) {
          // 改为上传到腾讯云
          storeAs = `/upload_hd_vod/${stroeName}.${fileFix}`;
        } else {
          storeAs = `/upload_vod/${stroeName}.${fileFix}`;
        }
      }
      upload = {
        client: null,
        tcVod: null,
        uploader: null,
        activity, // 课程对象
        file, // 文件
        fileFix, // 文件后缀
        stroeName, // 文件存储名称
        txStoreName, // 腾续云的存储名称
        storeAs, // 存储路径
        fileName: file.name, // 源文件名称
        fileSize: Math.floor((file.size / 1024 / 1024) * 100) / 100, // 文件大小
        schedule: 0, // 上传百分比
        status: 1, // 0失败, 1上传中,2转码中, 3成功, 4失败， 5成功
        isAudio, // 是否是音频文件
        parallel: 2, // 默认2个并行上传
        retryCount: 0, // 失败重试次数
        horizontal,
        isHighVod,
      };
      // commit(CREATE_UPLOAD, upload);
    }
    // 仅仅创建上传状态
    // 仅仅创建前三个的真实上传
    console.log("================================", upload);
    commit(CREATE_UPLOAD, upload);
    const uploadingArr = state.filter((cur) => cur.status === 1);
    if (uploadingArr.length > 3) {
      // 加入队列,但暂时不开启上传
      globalArr.push(upload);
    } else {
      dispatch("realUpload", upload);
    }
  },
  updateUpload({ commit }, upload) {
    console.log("updateUpload:", upload);
    commit(UPDATE_UPLOAD, upload);
  },

  deleteUpload({ commit, dispatch }, { activityId, upload }) {
    console.log(upload.status, upload.uploader);
    // status===3 表示上传成功，此时不是停止上传了，直接删除就行
    if (upload.status !== 3 && upload.uploader) {
      if (!upload.isAudio && upload.isHighVod && upload.uploader) {
        upload.uploader.cancel();
      } else {
        // if (client.abortMultipartUpload) {
        //   client.abortMultipartUpload(storeAs, uploadsId).then((res) => {
        //     /* eslint-disable */
        //     console.log(res);
        //     /* eslint-enable */
        //   });
        // }
      }
    }

    commit(DELETE_UPLOAD, activityId);
    if (globalArr.length > 0) {
      const nextUpload = globalArr.splice(0, 1)[0];
      dispatch("realUpload", nextUpload);
    }
  },
  removeUpload({ commit }, { activityId }) {
    commit(DELETE_UPLOAD, activityId);
  },
  retryUpload({ dispatch }, activityId) {
    let upload = {};
    for (let i = 0; i < state.length; i++) {
      if (state[i].activity.id === activityId) {
        upload = state[i];
      }
    }
    if (upload.file && upload.activity) {
      dispatch("updateUpload", { activity: upload.activity, status: 1 });
      // 重新调用上传
      dispatch("createUpload", {
        file: upload.file,
        activity: upload.activity,
        horizontal: upload.horizontal,
      });
    }
  },
  restartUpload({ dispatch }, activityId) {
    /* eslint-disable */
    for (const item in checkpoint) {
      if (item === `act_${activityId}`) {
        checkpoint[`act_${activityId}`] = null;
      }
    }
    /* eslint-enable */
    let upload = {};
    for (let i = 0; i < state.length; i++) {
      if (state[i].activity.id === activityId) {
        upload = state[i];
      }
    }
    if (upload.file && upload.activity) {
      upload.activity.restart = true;
      // upload.client.abortMultipartUpload(upload.storeAs, upload.uploadsId);
      dispatch("updateUpload", { activity: upload.activity, status: 1 });
      // 重新调用上传
      dispatch("createUpload", {
        file: upload.file,
        activity: upload.activity,
        horizontal: upload.horizontal,
      });
    }
  },
  async realUpload({ commit, dispatch }, upload) {
    /* eslint-disable */
    const activity = upload.activity;
    const actId = activity.id;
    const parallel = upload.parallel || 2;
    debugger;
    if (!upload.isAudio &&  upload.isHighVod) {
      // 腾讯云上传
      let tcVod = upload.tcVod;
      try {
        tcVod = await getTcVodClient(upload.activity.id, upload.horizontal);
        console.log(tcVod, "------------");
        commit(UPDATE_UPLOAD, { activity, tcVod });
      } catch (e) {
        console.log("http request error: " + e);
      }
      const uploader = tcVod.upload({
        mediaFile: upload.file.raw,
        mediaName: upload.txStoreName,
      });
      commit(UPDATE_UPLOAD, { activity, uploader });

      // 视频上传完成时
      uploader.on("media_upload", function (info) {
        console.log("media_upload", info);
      });
      // 视频上传进度
      uploader.on("media_progress", function (info) {
        console.log("media_progress", info);
        if (upload.retryCount > 0) {
          commit(UPDATE_UPLOAD, { activity, retryCount: 0 });
        }

        onProgress(info.percent, activity, dispatch);
      });
      uploader
        .done()
        .then(function (doneResult) {
          console.log("upload success:" + JSON.stringify(doneResult));
          // 回调结果说明
          // type doneResult = {
          //   fileId: string,
          //   video: {
          //     url: string
          //   }
          // }
          onSuccess(
            { commit, dispatch },
            activity,
            upload.file,
            upload.isAudio,
            upload.storeAs,
            upload
          );
        })
        .catch((err) => {
          uploadErrMessage(upload.activity, upload.file, {}, err);
          //retry
          console.log(upload.retryCount);
          if (upload.file && upload.file.size > 0 && upload.retryCount < 10) {
            let _parallel = parallel;
            // 当有超时错误时就不再并行上传，改为一个一个上传
            if (err.name === "ConnectionTimeoutError") {
              _parallel = 1;
            }
            commit(UPDATE_UPLOAD, {
              activity,
              parallel: _parallel,
              retryCount: upload.retryCount + 1,
            });
            console.error("retryCount : " + upload.retryCount);
            // 延时重试
            setTimeout(() => {
              dispatch("retryUpload", actId);
            }, upload.retryCount * (upload.retryCount + 1) * 1000);
          } else {
            onError(err, upload.file, activity, dispatch);
          }
        });
    } else {
      // 阿里云上传
      const progress = async function progress(percentage, cpt, res) {
        checkpoint[`act_${actId}`] = cpt;
        // 记录updateId
        if (!upload.uploadId) {
          commit(UPDATE_UPLOAD, { activity, uploadsId: cpt.uploadId });
        }
        if (upload.retryCount > 0) {
          commit(UPDATE_UPLOAD, { activity, retryCount: 0 });
        }
        onProgress(percentage, activity, dispatch);
      };

      const options = {
        parallel: parallel, // 并发2片上传
        progress: progress,
      };
      // 断点续传
      if (checkpoint[`act_${actId}`] !== undefined) {
        options.checkpoint = checkpoint[`act_${actId}`];
      }
      let client = upload.client;
      try {
        client = await getOssClient();
        commit(UPDATE_UPLOAD, { activity, client });
      } catch (e) {
        console.log("http request error: " + e);
      }

      client
        .multipartUpload(upload.storeAs, upload.file.raw, options)
        .then((res) => {
          console.log("upload success:" + JSON.stringify(res));
          onSuccess(
            { commit, dispatch },
            activity,
            upload.file.raw,
            upload.isAudio,
            upload.storeAs,
            upload
          );
        })
        .catch((err) => {
          if (client && client.isCancel()) {
            console.log("chancel upload");
          } else {
            console.error(err);
            uploadErrMessage(
              upload.activity,
              upload.file,
              checkpoint[`act_${actId}`],
              err
            );
            //retry
            console.log(upload.retryCount);
            if (upload.file && upload.file.raw.size > 0 && upload.retryCount < 10) {
              let _parallel = parallel;
              // 当有超时错误时就不再并行上传，改为一个一个上传
              if (err.name === "ConnectionTimeoutError") {
                _parallel = 1;
              }
              if (
                err.name === "EntityTooSmallError" &&
                checkpoint[`act_${actId}`]
              ) {
                let _cpt = checkpoint[`act_${actId}`];
                // etag 为 "D41D8CD98F00B204E9800998ECF8427E" 表示上传了个空数据片段
                const _doneParts = _cpt.doneParts.filter(
                  (s) => s.etag !== '"D41D8CD98F00B204E9800998ECF8427E"'
                );
                _cpt.doneParts = _doneParts;
                checkpoint[`act_${actId}`] = _cpt;
              }
              commit(UPDATE_UPLOAD, {
                activity,
                parallel: _parallel,
                retryCount: upload.retryCount + 1,
              });
              console.error("retryCount : " + upload.retryCount);
              // 延时重试
              setTimeout(() => {
                dispatch("retryUpload", actId);
              }, upload.retryCount * (upload.retryCount + 1) * 1000);
            } else {
              onError(err, upload.file, activity, dispatch);
            }
          }
        });
    }
  },
  /* eslint-enable */
};

/* eslint-disable */
// oss client options
function ossClientOptions(token) {
  return {
    region: "oss-cn-hangzhou",
    accessKeyId: token.data.AccessKeyId,
    accessKeySecret: token.data.AccessKeySecret,
    stsToken: token.data.SecurityToken,
    bucket: "rrjvideo",
    secure: true,
    timeout: 300000,
  };
}

async function getOssClient() {
  const token = await axios.get("https://renrenjiang.cn/stsToken");
  const client = new OSS(ossClientOptions(token));
  return client;
}

// 获取腾讯云点播上传
async function getTcVodClient(activityId, horizontal) {
  function getSignature() {
    const url = `https://api.renrenjiang.cn/api/v3/activities/${activityId}/tencent/upload/signature`;
    const params = {
      horizontal: horizontal,
      autoPublish: 0,
      target: "activity",
      next: "transcode",
    };
    return request.get(url, { params }).then((res) => {
      return res.sign;
    });
  }

  const tcVod = new TcVod({
    getSignature: getSignature,
  });

  return tcVod;
}

// 处理上传失败
function onError(err, file, activity, dispatch) {
  for (let i = 0; i < state.length; i++) {
    if (state[i].activity.id === activity.id) {
      const $vm = new Vue();
      if (err.message.indexOf("RequestTimeTooSkewed") >= 0) {
        $vm.$notify({
          type: "error",
          title: "上传文件失败",
          message: `文件${file.name}上传失败，请检查您电脑的当前时间是否正确，然后刷新页面重试！`,
          duration: 0,
        });
      } else if (err.message.indexOf("Network Error") >= 0) {
        $vm.$notify({
          type: "error",
          title: "上传文件失败",
          message: `已自动重试10次，文件${file.name}仍然上传失败，请检查网络状况，如确认网络畅通，请联系人人讲工作人员`,
          duration: 0,
        });
      } else if (file && file.size < 1) {
        $vm.$notify({
          type: "error",
          title: "文件读取失败",
          message: `视频${file.name}读取失败，请重新创建上传任务，并确保上传过程中你的视频文件不要被其他占用和改动`,
          duration: 0,
        });
      } else {
        $vm.$notify({
          type: "error",
          title: "上传文件失败",
          message: `文件${file.name}上传失败，请检查网络状况，如确认网络畅通，请联系人人讲工作人员`,
          duration: 0,
        });
      }
      dispatch("updateUpload", {
        activity,
        status: 0,
      });
    }
  }
}

function updateLocalstorage(upload) {
  // 上传成功后再localStorage里面存储一份，以处理未转码完成而用户刷新页面
  let uploadingList;
  uploadingList = window.localStorage.getItem("uploadingList");
  if (uploadingList) {
    uploadingList = JSON.parse(uploadingList);
    // 去除已存在的课程
    uploadingList = uploadingList.filter(
      (cur) => cur.activity.id !== upload.activity.id
    );
    const upload2 = { ...upload };
    upload2.uploader = null;
    uploadingList.push(upload2);
  } else {
    uploadingList = [];
    const upload2 = { ...upload };
    upload2.uploader = null;
    uploadingList.push(upload2);
  }
  window.localStorage.setItem("uploadingList", JSON.stringify(uploadingList));
}

// 处理上传进度
function onProgress(bytesUploaded, activity, dispatch) {
  if (bytesUploaded > 1.01) {
    // 上传超过100%，说明有问题，自动重传
    dispatch("restartUpload", activity.id);
  } else {
    console.log(bytesUploaded, activity, dispatch);
    const schedule = (bytesUploaded * 100).toFixed(2);
    dispatch("updateUpload", { activity, schedule, status: 1 });
  }
}

// 处理上传成功
function onSuccess({ dispatch }, activity, file, isAudio, storeAs, upload) {
  // 有任何一个上传成功，调用真正的上传函数
  const $vm = new Vue();
  $vm.$notify({
    type: "success",
    title: "上传文件完成",
    message: `文件${file.name}上传成功，请等待转码完成`,
    duration: 3000,
  });

  if (isAudio) {
    if (globalArr.length > 0) {
      const nextUpload = globalArr.splice(0, 1)[0];
      dispatch("realUpload", nextUpload);
    }
    dispatch("updateUpload", { activity, status: 3 });
    const streamUrl = encodeURIComponent(
      `https://video.renrenjiang.cn${storeAs}`
    );
    request.post(
      `/api/v3/activities/${activity.id}/media_type?media_type=audio&stream_url=${streamUrl}`
    );
    request.post(
      `/api/v3/activities/${activity.id}/publish`
    );
    
  } else {
    if (globalArr.length > 0) {
      const nextUpload = globalArr.splice(0, 1)[0];
      dispatch("realUpload", nextUpload);
    }
    dispatch("updateUpload", { activity, status: 2 });
    updateLocalstorage(upload);
    // 轮询转码状态
    const timer = setInterval(() => {
      axios
        .get(
          `https://stream.renrenjiang.cn/stream/notice/transcode/status?activity_id=${activity.id}`
        )
        .then((res) => {
          let uploadingList = window.localStorage.getItem("uploadingList");
          if (uploadingList) {
            uploadingList = JSON.parse(uploadingList);
          }
          if (res.data.result === "Success" || res.data.result === "SUCCESS") {
            for (let i = 0; i < state.length; i++) {
              if (state[i].activity.id === activity.id) {
                if (state[i].status !== 3 && state[i].status !== 5) {
                  clearInterval(timer);
                  const $vm = new Vue();
                  $vm.$notify({
                    type: "success",
                    title: "视频转码成功",
                    message: `视频：${activity.title} 转码成功！`,
                    duration: 0,
                  });
                  dispatch("updateUpload", { activity, status: 3 });
                  uploadingList = uploadingList.filter((cur) => {
                    return cur.activity.id !== upload.activity.id;
                  });
                  window.localStorage.setItem(
                    "uploadingList",
                    JSON.stringify(uploadingList)
                  );
                  break;
                } else {
                  clearInterval(timer);
                }
              }
            }
          } else if (
            res.data.result === "Skipped" ||
            res.data.result === "FAIL"
          ) {
            $vm.$notify({
              type: "error",
              title: "视频转码失败",
              message: `视频：${upload.activity.title} 转码失败！请检查视频文件是否损坏，是否能正常播放，若视频正常，请重新上传`,
              duration: 0,
            });
            uploadingList = uploadingList.filter((cur) => {
              return cur.activity.id !== upload.activity.id;
            });
            window.localStorage.setItem(
              "uploadingList",
              JSON.stringify(uploadingList)
            );
            dispatch("removeUpload", { activityId: upload.activity.id });
            clearInterval(timer);
          }
        });
    }, 2 * 60 * 1000);
  }
  // 记录成功信息
  uploadErrMessage(activity, file, {}, { name: "success", message: storeAs });
}

// 上传报错信息
function uploadErrMessage(activity, file, cpt, error) {
  const errMessage = {
    message: error.message,
    name: cpt.name,
    fileSize: cpt.fileSize,
    uploadId: cpt.uploadId,
  };
  const data = {
    userId: activity.user_id,
    userName: activity.creator && activity.creator.nickname || '',
    activityId: activity.id,
    activityTitle: activity.title,
    fileName: file.name,
    fileSize: file.size,
    userAgent: window.navigator.userAgent,
    errName: error.name,
    errMessage: JSON.stringify(errMessage),
  };
  request.post("/api/v3/es/upload_log", data);
}

/* eslint-enable */

const uploads = {
  state: {
    state,
    checkpoint,
    globalArr,
  },
  mutations,
  actions,
};
export default uploads;
